import { render } from "./create.vue?vue&type=template&id=37a6230f"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/customer_products/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37a6230f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37a6230f', __exports__)) {
    console.log('reload')
    api.reload('37a6230f', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=37a6230f", () => {
    console.log('re-render')
    api.rerender('37a6230f', render)
  })

}


export default __exports__